import React from 'react';

const IndentCellRenderer = (params) => {
  return <span style={{ marginLeft: 30 }}>{params.value}</span>;
};

export default IndentCellRenderer;
